<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

              <el-form :model="editForm" :rules="rules" ref="editForm">

                <el-row class="row">
                  <el-col :span="12" class="item">
                    <el-form-item label="老人">
                      <el-input v-model="editForm.elderlyName" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="item">
                    <el-form-item label="用药组名称" required prop="groupName">
                      <el-input v-model="editForm.groupName" placeholder="请输入用药组名称"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row class="row">
                  <el-col :span="24" class="item">
                    <el-form-item label="用药详情" required prop="itemNameArr">
                      <div style="width:100%;margin-top:40px">
                        <el-tag
                            :key="tag"
                            v-for="tag in editForm.itemNameArr"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                          {{tag}}
                        </el-tag>
                        <el-input
                            class="input-new-tag"
                            v-if="inputVisible"
                            v-model="inputValue"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="handleInputConfirm"
                            @blur="handleInputConfirm">
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 药品添加</el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click.native="confirm('editForm')">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Edit',
        props: [],
        data() {
            return {

              loading: false,

              editForm:{
                timeStr:timeStr,
                sign:'',
                staffCode:getStaffCode(),
                elderlyCode:'',
                elderlyName:'',
                itemNameArr:'',
                groupName:'',
                status:0,
                medicationGroupCode:'',
              },

              inputVisible: false,
              inputValue: '',

              rules:{
                groupName:[
                  { required: true, message: '请输入用药组名称', trigger: 'blur' },
                ],
                itemNameArr:[
                  { required: true, message: '请输入药品名称', trigger: 'blur' },
                ],
              }


            }
        },
        methods: {
            init(row){


              this.editForm.elderlyCode=row.elderlyCode;
              this.editForm.elderlyName = row.elderlyName;
              this.editForm.groupName = row.name;
              this.editForm.medicationGroupCode = row.medicationGroupCode;

              var list=[]
              var medicationItemList=row.listMedicationItem;
              for(var i in medicationItemList){
                list[i]=medicationItemList[i].name
              }
              this.editForm.itemNameArr=list;

            },

            closeSelf() {
                this.$emit("closeEdit");
            },



          handleClose(tag) {
            this.editForm.itemNameArr.splice(this.editForm.itemNameArr.indexOf(tag), 1);
          },
          showInput() {
            this.inputVisible = true;
            this.$nextTick(value => {
              console.log(value)
              this.$refs.saveTagInput.$refs.input.focus();
            });
          },
          handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
              this.editForm.itemNameArr.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
          },


          confirm(editForm){
            this.$refs[editForm].validate((valid) => {
              if(valid){
                this.addSubmit();
              }else {
                console.log('error submit!!');
                return false;
              }
            })

          },

          addSubmit(){


                this.loading = true;

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'MedicationGroup/Edit',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                      elderlyCode:this.editForm.elderlyCode,
                      groupName:this.editForm.groupName,
                      status:this.editForm.status,
                      itemNameArr:this.editForm.itemNameArr,
                      medicationGroupCode:this.editForm.medicationGroupCode,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.$emit("closeEdit");
                        this.$emit("getList");
                    }else{
                        this.$message(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },



        }
    }
</script>


<style>
.el-tag{
  margin-right: 10px;
}
.button-new-tag {
  height: 35px;
  line-height: 35px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 120px;
  vertical-align: bottom;
}
</style>
<style  lang="scss" scoped >


</style>
